"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.Overlay = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styled_div_1 = __importDefault(require("./styled-div"));
const icon_1 = require("./icon");
const utils_1 = require("../lib/utils");
const theme_1 = __importDefault(require("../styles/theme"));
const typography_1 = require("../styles/typography");
/**
 *
 * Modal Usage Example:
 *
 *  <Modal
 *    modalTitle="Modal Title"
 *    setShow={setShow}
 *    modalFooter={modalFooter}
 *  >
 *    {children}
 *  </Modal>
 *  )}
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
exports.Overlay = styled_components_1.default.span `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, ${(props) => props.theme.overlayOpacity});
`;
const ModalContainer = styled_components_1.default.span `
  border-radius: ${(props) => props.theme.borderRadius};
  background-color: ${(props) => props.theme.colors.white};
  padding: 40px;
  justify-content: center;
  position: fixed;
  width: 420px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;
const ModalContent = styled_components_1.default.div ``;
const Header = styled_components_1.default.div `
  color: ${(props) => props.theme.colors.textDark};
  position: relative;
  margin-bottom: 24px;
`;
const Title = styled_components_1.default.h2 `
  ${typography_1.defaultText}
  margin: 0;
`;
const Modal = (_a) => {
    var { modalTitle, children, modalFooter = null, onClose, onOverlayClick = utils_1.noop } = _a, commonProps = __rest(_a, ["modalTitle", "children", "modalFooter", "onClose", "onOverlayClick"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.Overlay, { "data-testid": "modal-overlay", onClick: onOverlayClick }),
        react_1.default.createElement(ModalContainer, Object.assign({}, commonProps),
            react_1.default.createElement(Header, { style: { display: 'flex', justifyContent: 'space-between' } },
                react_1.default.createElement(Title, { id: "title" }, modalTitle),
                onClose && (react_1.default.createElement(icon_1.IconButton, { ariaLabel: "clear", color: theme_1.default.colors.textDark, name: "close", onClick: onClose }))),
            react_1.default.createElement(ModalContent, null,
                react_1.default.createElement(styled_div_1.default, null, children),
                modalFooter && react_1.default.createElement(styled_div_1.default, { marginTop: "s" }, modalFooter)))));
};
exports.Modal = Modal;
exports.default = exports.Modal;
